import styled from 'styled-components';

export default styled.p`
  text-align: left;
  margin-left: 12px;
  margin-top: 0;
  font-size: 14px !important;
`;
